import React, { useContext } from 'react'
import { JourneyContext } from '../context/journeyContext'
import DOMPurify from 'dompurify'
import { getDynamicTextContent } from '../services/dynamicHeadings'
import { ConditionContext } from '../context/conditionContext'


export default function ComponentTextParagraph(props) {
   const [conditionState] = useContext(ConditionContext)
   const [journeyState, setJourneyState] = useContext(JourneyContext)
   const sanitizedContent = DOMPurify.sanitize(
      getDynamicTextContent({
         sectionId: props.sectionId,
         content: props.data.Content,
         conditionState,
         journeyState,
         sections: props.sections,
      })
   )
   

    return (
         <>
            <label className="inp-label">
            </label>
            <div dangerouslySetInnerHTML={{"__html":sanitizedContent}}></div>
         </>
        )

}
